/*=========================================================================================
  File Name: store.js
  Description: Main Store File
  ----------------------------------------------------------------------------------------
  Item Name: Vuex Store Module
  Author: Tan Tran
==========================================================================================*/

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import app from './modules/app/index'
import auth from './modules/auth/index'
import orderManager from './modules/orderManager/index'
import ordering from './modules/ordering/index'
import orders from './modules/orders/index'
import hub from './modules/hub/index'
import products from './modules/products/index'
import categories from './modules/categories/index'
import menus from './modules/menus/index'
import localization from './modules/localization/index'
import openingHours from './modules/openingHours/index'
import restaurant from './modules/restaurant/index'
import phoneService from './modules/phoneService/index'
import pos from './modules/pos/index'
export default new Vuex.Store({
    modules : {
        app : app,
        auth : auth,
        orderManager : orderManager,
        hub : hub,
        menus : menus,
        products : products,
        categories : categories,
        localization : localization,
        openingHours : openingHours,
        ordering : ordering,
        restaurant : restaurant,
        orders : orders,
        phoneService : phoneService,
        pos : pos
    }
})